var render = function render(){var _vm=this,_c=_vm._self._c;return _c('woot-reports',{key:"team-reports",attrs:{"type":"team","getter-key":"teams/getTeams","action-key":"teams/get","download-button-label":_vm.$t('TEAM_REPORTS.DOWNLOAD_TEAM_REPORTS')}})
}
var staticRenderFns = []

export { render, staticRenderFns }